import $ from 'jquery';
import Cookies from 'js-cookie';

$(document).ready(() => {
    $('.st_notification_wrap').each(function(){
        let that = $(this);
        if(that.data('delay'))
            setTimeout(function(){that.show();}, that.data('delay') * 1000);
        else
            that.show();

        let id_st = that.data('id_st');
        let show_box = that.data('show_box');
        $('.notification_accept, .st_notification_close').click(function () {
            that.hide();
            if (!show_box) {
                Cookies.set('st_notification_'+id_st, show_box, {
                    'expires': 30,
                    'domain': sttheme.cookie_domain,
                    'path': sttheme.cookie_path
                });
            } else {
                Cookies.set('st_notification_'+id_st, show_box, {
                    'expires':-1,
                    'domain': sttheme.cookie_domain,
                    'path': sttheme.cookie_path
                }); 
            }
        });
        if(show_box==2)
            Cookies.set('st_notification_'+id_st, show_box, {
                'expires': 30,
                'domain': sttheme.cookie_domain,
                'path': sttheme.cookie_path
            });
    });
});



// WEBPACK FOOTER //
// ./js/stnotification.js


// WEBPACK FOOTER //
// ./js/stnotification.js


// WEBPACK FOOTER //
// ./js/stnotification.js


// WEBPACK FOOTER //
// ./js/stnotification.js


// WEBPACK FOOTER //
// ./js/stnotification.js


// WEBPACK FOOTER //
// ./js/stnotification.js


// WEBPACK FOOTER //
// ./js/stnotification.js


// WEBPACK FOOTER //
// ./js/stnotification.js


// WEBPACK FOOTER //
// ./js/stnotification.js


// WEBPACK FOOTER //
// ./js/stnotification.js


// WEBPACK FOOTER //
// ./js/stnotification.js


// WEBPACK FOOTER //
// ./js/stnotification.js


// WEBPACK FOOTER //
// ./js/stnotification.js


// WEBPACK FOOTER //
// ./js/stnotification.js


// WEBPACK FOOTER //
// ./js/stnotification.js


// WEBPACK FOOTER //
// ./js/stnotification.js